<template>
  <div>
    <new-ol-map-base
      ref="mapBase"
      :layers="monitoringLayers"
      :location="location"
      :searchResult="searchResult"
      @onMapReady="onMapReady($event)"
      @mapPointerMove="onPointerMove($event)"
      @mapClick="onClick($event)"
    ></new-ol-map-base>

    <tooltip-card-map
      v-show="map"
      :tooltipParams="tooltipParams"
    >
    </tooltip-card-map>
  </div>
</template>

<script>
import "ol/ol.css";
import VectorSource from 'ol/source/Vector';
import { TileWMS } from "ol/source";
import { getTooltipPropertiesOfLayer, getTooltipPropertiesFromFeature, getSubLayerByProperty, initHighlightStyle } from '@/ol-maps/functions';
import {getSublayers, getDataFeatures, addOverlayMap} from '@/ol-maps/factory';
import NewOlMapBase from '../common/NewOlMapBase.vue';
import TooltipCardMap from '../common/TooltipCardMap.vue';
import GeoJSON from "ol/format/GeoJSON";
import { useEscassezReference } from '../../helpers/reference_date'

const { fetchEscassezReference } = useEscassezReference();

export default {
  name: "MonitoringMap",
  props:['searchResult', 'location'],
  components:{
    NewOlMapBase,
    TooltipCardMap
  },
  data: () => ({
    //dialog: false,
    view: undefined,
    map: undefined,
    overlaysGroup: [],
    overlayTooltipText: undefined,
    overlayLayerTooltip: undefined,
    tooltipParams:[],
    flag: undefined,
    overlayLayerTooltipCard: undefined,
    featureOverlay: undefined,
  }),
  watch:{
    location(){
      this.changeLayerLocationIdProperty();
    }
  },
  computed: {
    monitoringLayers () {
      return this.$store.getters.monitoringLayers
    },
    timeFeatures () {
      return this.$store.getters.timeFeatures
    },
  },
  created () { this.initialize() },
  methods: {
    async initialize(){
      await this.$store.dispatch('loadMonitoringLayers');
      this.overlaysGroup = await getSublayers(this.monitoringLayers);
      await fetchEscassezReference(this.monitoringLayers, 2000);
      if (this.$refs.mapBase) {
        this.$refs.mapBase.initialize();
      }

    },
    onMapReady(value){
      const {map, view} = value;
      this.map = map;
      this.view = view;
      this.addTooltipOverlay();
      // this.$refs.mapBase.checkMapModal();
    },

    async onClick(e){
      const me = this;
      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(e.pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if(propertiesLayer.event_params){
          if(propertiesLayer.event_params.type === 'click'){
            const fetchData = async () => {
              const view = me.map.getView();
              const features = await getDataFeatures(e, source, view);
              const feature_properties = features[0];
              me.emitClick(feature_properties);
            }
            fetchData();
          }
        }
      });
    },

    async onPointerMove(e){
      const me = this;
      this.flag = e.pixel

      if(this.featureOverlay){
        this.featureOverlay.getSource().clear(true);
      }

      await new Promise(r => setTimeout(r, 100));
      if(this.flag != e.pixel){
        return;
      }
      this.flag = undefined
      let pixel = me.map.getEventPixel(e.originalEvent);
      me.clearTooltipParams();
      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if(source instanceof TileWMS && propertiesLayer.tooltip_params && !propertiesLayer.hide_on_menu){
          const view = me.map.getView();
          const fetchData = async () => {
            const features = await getDataFeatures(e, source, view);
            // highlightStyle
            let feature = features[0];
            if(feature && propertiesLayer){
              if(propertiesLayer.property_params){
                if(propertiesLayer.property_params.highlightOnHoverFeature){
                  let show_highlights = propertiesLayer.property_params.highlightOnHoverFeature;

                  let vectorSource = new VectorSource({
                    features: (new GeoJSON().readFeatures(feature))
                  });

                  // add highlights
                 if (show_highlights) {
                    const { fillColor, strokeColor } = show_highlights;
                    if(me.featureOverlay){
                       me.featureOverlay.getSource().clear(true);
                    }
                    me.featureOverlay = initHighlightStyle(me.map, fillColor, strokeColor);
                    me.featureOverlay.setSource(vectorSource);
                  }
                }
              }
            }
            // highlightStyle
            document.getElementById('map').style.cursor = 'pointer';// map cursor style
            if(features && features.length > 0) {
              const {keys, icon_params} = getTooltipPropertiesOfLayer(propertiesLayer);
              features.forEach(feature_properties => {
                me.addTooltipParams(
                  {
                    ...getTooltipPropertiesFromFeature(keys, feature_properties.properties),
                    name: propertiesLayer.name,
                    zindex: propertiesLayer.property_params.zindex,
                    updatedAt: feature_properties.properties.date ?? feature_properties.properties.date,
                    icon_params: propertiesLayer.icon_params ? propertiesLayer.icon_params  : icon_params
                  }
                );
              });
              me.overlayLayerTooltipCard.setPosition(e.coordinate);
            }
          }
          fetchData();
        } else {
          document.getElementById('map').style.cursor = '';// map cursor style
          //this.featureOverlay.getSource().clear(true);
        }
      });

      if(this.tooltipParams.length === 0){
        me.overlayLayerTooltipCard.setPosition(undefined);
      }
    },
    addTooltipOverlay(){
      const tooltipCard = document.getElementById("tooltip-card");
      this.overlayLayerTooltipCard = addOverlayMap(this.map, tooltipCard, 'bottom-center');
    },
    addTooltipParams(params){
      this.tooltipParams.push(params);
    },
    clearTooltipParams(){
      this.tooltipParams = [];
    },
    emitClick(feature_properties){
      if(feature_properties.properties){
        if(feature_properties.properties.sbsid){
          //this.dialog = true
          this.$emit('idClick', feature_properties.properties.sbsid);
        } else {
          //this.dialog = true
          this.$emit('idClick', feature_properties.properties.cptlocationref);

        }
      }
    },
    changeLayerLocationIdProperty(){

      if(this.map && this.location){
        const sublayer = getSubLayerByProperty(this.map, 'id', 733);

        if(sublayer){
          const source = sublayer.getSource();
          const params = source.getParams();
          source.updateParams({...params, VIEWPARAMS: `locationid:${this.location.locationid}`});
        }
      }
    },
  },
}
</script>

<style scoped>
</style>
